module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921121149_T.a3f21d3c.jpg";